import * as React from 'react'
// libs
import styled from 'styled-components'
import { InjectedFormProps, reduxForm } from 'redux-form'
// components
import Grid from '@mui/material/Grid2'
// context
import { StrategyActionsBLContext } from 'containers/StrategyActions/layers/BL'
// constants
import { Forms } from 'constants/index'
import { STATUS_FILTERS } from 'constants/home'
// view components
import Menu from './components/Menu'
import Search from './components/Search'
import PersonFilter from './components/PersonFilter'
import TimeFrameFilter from './components/TImeFrameFilter'
// utils
import moment from 'moment'

// styled
const Wrapper = styled(Grid)`
  && {
    margin-bottom: 16px;
    width: 75%;

    @media (max-width: 768px) {
      margin-top: 20px;
      width: 100%;
      justify-content: space-between;

      > button {
        padding: 0;
      }
    }
  }
`

const GroupSection = styled(Grid)`
  && {
    margin-left: auto;
    width: unset;
  }
`

// constant
const GRID_STYLE = { fontSize: '14px', whiteSpace: 'nowrap' as const }

const FilterPanel: React.FC<InjectedFormProps> = ({ handleSubmit }) => {
  const { handleSetIsGroupedByPlan, handleSetStatusFilter, isGroupedByPlan, statusFilter } =
    React.useContext(StrategyActionsBLContext)

  // constants
  const STATUS_FILTER_OPTIONS = [
    { label: 'Open tasks', value: STATUS_FILTERS.OPEN, onClick: handleSetStatusFilter(STATUS_FILTERS.OPEN) },
    { label: 'Overdue tasks', value: STATUS_FILTERS.OVERDUE, onClick: handleSetStatusFilter(STATUS_FILTERS.OVERDUE) },
    { label: 'All tasks', value: STATUS_FILTERS.ALL, onClick: handleSetStatusFilter(STATUS_FILTERS.ALL) }
  ]

  const GROUPING_FILTER_OPTIONS = [
    { label: 'Plan', onClick: handleSetIsGroupedByPlan(true) },
    { label: 'None', onClick: handleSetIsGroupedByPlan(false) }
  ]

  return (
    <Wrapper container alignItems={'center'}>
      <Menu
        title={STATUS_FILTER_OPTIONS.find((option) => option.value === statusFilter).label}
        options={STATUS_FILTER_OPTIONS}
      />
      <PersonFilter handleSubmit={handleSubmit} />
      <TimeFrameFilter />
      <GroupSection container direction={'row'} alignItems={'center'} wrap={'nowrap'}>
        <Grid style={GRID_STYLE}>Group by:</Grid>
        <Menu title={isGroupedByPlan ? 'Plan' : 'None'} options={GROUPING_FILTER_OPTIONS} />

        <Search name={'description'} />
      </GroupSection>
    </Wrapper>
  )
}

export default reduxForm<any>({
  form: Forms.HOME_PAGE_FILTER_FORM,
  initialValues: {
    startPeriod: moment().toISOString(),
    endPeriod: moment().add(1, 'week').toISOString()
  }
})(FilterPanel)
